<template>
  <sidenav :orientation="orientation" :class="curClasses">
    <!-- Brand demo (see src/demo.css) -->
    <div class="app-brand demo" v-if="orientation !== 'horizontal'">
      <router-link to="/" class="app-brand-text demo sidenav-text font-weight-normal ml-2">
        <span class="app-brand-logo demo">
          <img
            v-if="$store.getters.generic.settings && $store.getters.generic.settings.dashboard_logo"
            :src="backend_url + $store.getters.generic.settings.dashboard_logo"
            alt="img"
          />
        </span>
      </router-link>
      <a
        href="javascript:void(0)"
        class="layout-sidenav-toggle sidenav-link text-large ml-auto"
        @click="toggleSidenav()"
      >
        <i class="ion ion-md-menu align-middle"></i>
      </a>
    </div>
    <div class="sidenav-divider mt-0" v-if="orientation !== 'horizontal'"></div>
    <!-- Raporlar Sayfası İçin Özelleştirilmiş Sidebar -->
    <div v-if="isReports" class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }" style="height: 26rem">
      <ReportLayout></ReportLayout>
    </div>
    <div v-else class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }" style="height: 26rem">
      <sidenav-router-link
        v-for="page in notMenuListFilter(menu_list)"
        :to="{ name: page.name }"
        :icon="page.icon"
        :key="page.title"
        :exact="true"
      >
        {{ $t(page.title) }}
      </sidenav-router-link>
      <sidenav-menu
        v-for="page in menuListFilter(menu_list)"
        :key="page.title"
        :to="{ name: page.name }"
        :icon="page.icon"
        :active="isMenuActive(current_page)"
        :open="isMenuOpen(page)"
      >
        <template slot="link-text">{{ $t(page.title) }}</template>
        <sidenav-router-link
          v-for="child in childrenFilter(page.children)"
          :to="{ name: child.name }"
          :icon="child.icon"
          :key="child.title"
          :exact="true"
        >
          {{ $t(child.title) }}
        </sidenav-router-link>
      </sidenav-menu>
    </div>
  </sidenav>
</template>

<script>
import { Sidenav, SidenavRouterLink, SidenavMenu } from '@/vendor/libs/sidenav';
import ReportLayout from '@/components/layouts/ReportLayouts';
import router from '@/router';
import { API_BASE_URL } from '@/config';
import axios from 'axios';
import store from '@/store';
import { getSystemSettings } from '../../utils/index';

export default {
  name: 'app-layout-sidenav',
  data() {
    return {
      backend_url: store.getters.DOMAIN,
      current_page: '',
      menu_list: [],
      setting: null,
      isReports: false,
    };
  },
  components: {
    Sidenav,
    SidenavRouterLink,
    SidenavMenu,
    ReportLayout,
  },

  props: {
    orientation: {
      type: String,
      default: 'vertical',
    },
  },

  computed: {
    curClasses() {
      let bg = this.layoutSidenavBg;

      if (
        this.orientation === 'horizontal' &&
        (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)
      ) {
        bg = bg.replace(' sidenav-dark', '').replace(' sidenav-light', '').replace('-darker', '').replace('-dark', '');
      }

      return (
        `bg-${bg} ` +
        (this.orientation !== 'horizontal' ? 'layout-sidenav' : 'layout-sidenav-horizontal container-p-x flex-grow-0')
      );
    },
  },
  created() {
    this.changeSideMenu();
  },
  methods: {
    childrenFilter(children) {
      return children.filter(c => !c.hide && c.meta && this.$store.getters.permissions.includes(c.meta.perm));
    },
    menuListFilter(menuList) {
      return menuList.filter(
        p => p.children && !p.hide && p.meta && this.$store.getters.permissions.includes(p.meta.perm)
      );
    },
    notMenuListFilter(menuList) {
      return menuList.filter(p => !p.children && !p.hide);
    },
    isMenuActive(url) {
      return this.$route.path.indexOf(url) === 0;
    },
    isMenuOpen(url) {
      let current_page = this.$store.state.page.page.split('/')[2];
      for (let i = 0; i < url.children.length; i++) {
        if (url.children[i].name === current_page) {
          return true;
        }
      }
      //return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal';
    },
    toggleSidenav() {
      this.layoutHelpers.toggleCollapsed();
    },
    changeSideMenu() {
      let page = this.$store.state.page.page.split('/')[1];
      this.isReports = page === 'report' ? true : false;
      this.menu_list = router.options.routes.filter(item => {
        if (page === item.name) {
          return item;
        }
      });
      this.menu_list = this.menu_list[0].children;
    },
  },
  watch: {
    $route(to, from) {
      this.changeSideMenu();
    },
  },
  mounted() {
    getSystemSettings();
  },
};
</script>
